import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import type { CompInfoDependency } from '@wix/editor-elements-types/thunderbolt';
import {
  StripSlideshowCarmiData,
  StripSlideshowDefinition,
  IStripSlideshowMapperProps,
} from '../StripSlideshow.types';
import { props as viewerPropsMapper } from './StripSlideshow.mapper';

const viewerDeps = Object.keys(
  viewerPropsMapper.deps,
) as Array<CompInfoDependency>;

const props = withCompPreviewProps<
  IStripSlideshowMapperProps,
  StripSlideshowDefinition,
  StripSlideshowCarmiData
>()(['isPlayingAllowed', ...viewerDeps], (deps, carmiData) => {
  const viewerProps = viewerPropsMapper.resolver(deps, carmiData);
  return {
    ...viewerProps,
    isPlayingAllowed: deps.isPlayingAllowed,
  };
});

export default createComponentPreviewMapperModel({
  props: props as any,
});
